<div class="full-height-tracker">
  <!-- Loading Skeleton Overlay -->
  <div class="map-skeleton-overlay" *ngIf="loadingMarkers">
    <div class="skeleton-map-content skeleton-block"></div>
  </div>
  <!-- Premium Header -->
  <div class="track-modal-header" *ngIf="!isComponent || showHeader">
    <div class="header-main-info">
      <div class="tracking-dot"></div>
      <h2 class="modal-title" *ngIf="!isComponent">{{ data?.isDriverDetail ? 'Driver Live Tracking' : 'Live Order
        Tracking' }}</h2>
      <h2 class="modal-title" *ngIf="isComponent && showHeader">{{ customHeaderTitle }}</h2>
    </div>
    <button class="modal-close-btn" *ngIf="!isComponent || showHeader" (click)="onDismiss()" title="Close">✕</button>
  </div>

  <div class="map-container" (wheel)="onMapWheel($event)">
    <!-- 🔹 Session Expired Overlay — shown when the 15-min timer fires -->
    <div class="tracking-paused-overlay" *ngIf="isTrackingSessionExpired && locatedriver">
      <div class="tracking-paused-content">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
          <line x1="12" y1="9" x2="12" y2="13"></line>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
        <span class="paused-text">Live tracking paused</span>
        <button class="resume-tracking-btn" (click)="resumeTrackingSession()">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="1 4 1 10 7 10"></polyline>
            <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
          </svg>
          Resume Tracking
        </button>
      </div>
    </div>
    <google-map *ngIf="isComponent && !showdriver" class="GoogleMap" width="100%" [center]="center"
      [options]="mapOptions" [height]="height ? height : '100%'" (mapDragstart)="onMapDragStart()"
      (mapDragend)="onMapDragEnd()" (zoomChanged)="onMapZoomChanged()">
      <map-traffic-layer *ngIf="showTraffic"></map-traffic-layer>
      <!-- Manual Recalculate Route Button -->
      <div *ngIf="isOffRoute && selectedDriverOrderData?.destination"
        style="position: absolute; left: 50%; top: 35%; transform: translate(-50%, -50%); z-index: 1000; pointer-events: auto;">
        <button (click)="drawDriverRouteFromBackend()"
          style="background: #1e293b; color: white; border: 1px solid rgba(255,255,255,0.15); border-radius: 20px; padding: 8px 20px; font-size: 13px; font-weight: 600; cursor: pointer; box-shadow: 0 8px 16px rgba(0,0,0,0.4); display: flex; align-items: center; gap: 8px; transition: all 0.2s; backdrop-filter: blur(10px);"
          onmouseover="this.style.background='#334155'; this.style.transform='scale(1.02)';"
          onmouseout="this.style.background='#1e293b'; this.style.transform='scale(1)';"
          title="Recalculate route from current position">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="#10b981" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="1 4 1 10 7 10"></polyline>
            <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
          </svg>
          Recalculate Route
        </button>
      </div>

      <div class="map-top-right-controls">
        <ng-content select="[map-filters]"></ng-content>
        <div class="map-dropdown-wrapper" [class.open]="isDropdownOpen">
          <div class="dropdown-trigger" (click)="toggleDropdown()">
            <span class="placeholder" *ngIf="!selectedDriverLabel">Select Driver</span>
            <span class="selected-value" *ngIf="selectedDriverLabel">{{ selectedDriverLabel }}</span>
            <div class="custom-arrow"></div>
          </div>

          <div class="dropdown-list-container" *ngIf="isDropdownOpen">
            <div class="dropdown-item clear-selection" (click)="clearDriverSelection()">
              <span class="driver-name-text" style="color: #1e293b; font-weight: 600;">-- Select Driver --</span>
            </div>
            <div class="dropdown-item" *ngFor="let marker of uniqueDriver" (click)="selectCustomDriver(marker)">
              <span class="status-dot-css" [class.online]="marker.label.isOnline"></span>
              <span class="driver-name-text">{{ marker?.label?.name }}</span>
              <span *ngIf="marker.label.headdriver" class="hd-badge"
                style="background: linear-gradient(135deg, #f59e0b, #d97706); color: #ffffff; padding: 1px 5px; border-radius: 4px; font-size: 9px; font-weight: 800; letter-spacing: 0.5px; box-shadow: 0 1px 3px rgba(0,0,0,0.3); margin-left: 6px; display: inline-flex; align-items: center; justify-content: center; height: 16px; box-sizing: border-box; line-height: 1;">HD</span>
            </div>
          </div>
        </div>

        <button class="map-refresh-btn" *ngIf="locatedriver" (click)="onRefreshClicked()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
          </svg>
          Refresh Location
        </button>
      </div>

      <!-- Unified Premium Map Controls (Right Side) -->
      <div class="map-controls-stack">
        <button class="map-control-btn fullscreen" (click)="toggleFullscreen()" [class.active]="isFullscreen"
          title="Toggle Fullscreen">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3">
            </path>
          </svg>
        </button>
        <div class="control-divider"></div>
        <button class="map-control-btn dark-mode" (click)="toggleDarkMode()" [class.active]="isDarkMode"
          title="Toggle Dark Mode">
          <!-- Moon Icon (when off) / Sun Icon (when on) -->
          <svg *ngIf="!isDarkMode" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
          </svg>
          <svg *ngIf="isDarkMode" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="5"></circle>
            <line x1="12" y1="1" x2="12" y2="3"></line>
            <line x1="12" y1="21" x2="12" y2="23"></line>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
            <line x1="1" y1="12" x2="3" y2="12"></line>
            <line x1="21" y1="12" x2="23" y2="12"></line>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
          </svg>
        </button>

        <div class="control-divider"></div>

        <button class="map-control-btn map-type" (click)="toggleMapType()" [class.active]="isSatellite"
          title="Toggle Satellite View">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="2" y1="12" x2="22" y2="12"></line>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
          </svg>
        </button>

        <div class="control-divider"></div>

        <button class="map-control-btn view-3d" (click)="toggle3D()" [class.active]="is3D" title="Toggle 3D View">
          <span style="font-weight: 700; font-size: 15px; font-family: sans-serif;">3D</span>
        </button>

        <div class="control-divider"></div>

        <button class="map-control-btn traffic" (click)="toggleTraffic()" [class.active]="showTraffic"
          title="Toggle Traffic">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2v20M2 12h20" />
            <path d="M18 8l4 4-4 4M6 8l-4 4 4 4" />
          </svg>
        </button>

        <div class="control-divider"></div>

        <button class="map-control-btn center" (click)="reCenterMap()" title="Center to Driver">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="22" y1="12" x2="18" y2="12"></line>
            <line x1="6" y1="12" x2="2" y2="12"></line>
            <line x1="12" y1="6" x2="12" y2="2"></line>
            <line x1="12" y1="22" x2="12" y2="18"></line>
          </svg>
        </button>

        <div class="control-divider"></div>

        <button class="map-control-btn fit-all" (click)="fitRoute()" title="Fit Full Route">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 14l6-6 4 4 6-6" />
            <path d="M14 6h6v6" />
          </svg>
        </button>

        <div class="control-divider"></div>

        <button class="map-control-btn fit-all" (click)="fitAllDrivers()" title="Fit All Drivers">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z" />
          </svg>
        </button>

        <div class="control-divider"></div>

        <button class="map-control-btn zoom-in" (click)="zoomIn()" title="Zoom In">
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
          </svg>
        </button>

        <div class="control-divider"></div>

        <button class="map-control-btn zoom-out" (click)="zoomOut()" title="Zoom Out">
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M20 12H4" />
          </svg>
        </button>
      </div>
      <ng-container *ngIf="data?.isShowDirections || locatedriver">
        <map-polyline *ngIf="trimmedRoutePath && trimmedRoutePath.length > 0" [path]="trimmedRoutePath"
          [options]="{ strokeColor: isOffRoute ? 'transparent' : '#0088FF', strokeOpacity: 0.8, strokeWeight: 5 }">
        </map-polyline>
      </ng-container>
    </google-map>

    <google-map *ngIf="isComponent && showdriver" class="GoogleMap" width="100%" [height]="height ? height : '500px'"
      [center]="center" [options]="mapOptions" (mapDragstart)="onMapDragStart()" (mapDragend)="onMapDragEnd()"
      (zoomChanged)="onMapZoomChanged()">
      <map-traffic-layer *ngIf="showTraffic"></map-traffic-layer>

      <!-- Manual Recalculate Route Button -->
      <div *ngIf="isOffRoute && selectedDriverOrderData?.destination"
        style="position: absolute; left: 50%; top: 35%; transform: translate(-50%, -50%); z-index: 1000; pointer-events: auto;">
        <button (click)="drawDriverRouteFromBackend()"
          style="background: #1e293b; color: white; border: 1px solid rgba(255,255,255,0.15); border-radius: 20px; padding: 8px 20px; font-size: 13px; font-weight: 600; cursor: pointer; box-shadow: 0 8px 16px rgba(0,0,0,0.4); display: flex; align-items: center; gap: 8px; transition: all 0.2s; backdrop-filter: blur(10px);"
          onmouseover="this.style.background='#334155'; this.style.transform='scale(1.02)';"
          onmouseout="this.style.background='#1e293b'; this.style.transform='scale(1)';"
          title="Recalculate route from current position">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="#10b981" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="1 4 1 10 7 10"></polyline>
            <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
          </svg>
          Recalculate Route
        </button>
      </div>

      <ng-container *ngIf="data?.isShowDirections || locatedriver || data?.isDriverDetail">
        <map-polyline *ngIf="trimmedRoutePath && trimmedRoutePath.length > 0" [path]="trimmedRoutePath"
          [options]="{ strokeColor: isOffRoute ? 'transparent' : '#0088FF', strokeOpacity: 0.8, strokeWeight: 5 }">
        </map-polyline>
      </ng-container>

      <div class="map-controls-stack">
        <button class="map-control-btn fullscreen" (click)="toggleFullscreen()" [class.active]="isFullscreen"
          title="Toggle Fullscreen">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3">
            </path>
          </svg>
        </button>
        <div class="control-divider"></div>
        <button class="map-control-btn dark-mode" (click)="toggleDarkMode()" [class.active]="isDarkMode"
          title="Toggle Dark Mode">
          <!-- Moon Icon (when off) / Sun Icon (when on) -->
          <svg *ngIf="!isDarkMode" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
          </svg>
          <svg *ngIf="isDarkMode" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="5"></circle>
            <line x1="12" y1="1" x2="12" y2="3"></line>
            <line x1="12" y1="21" x2="12" y2="23"></line>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
            <line x1="1" y1="12" x2="3" y2="12"></line>
            <line x1="21" y1="12" x2="23" y2="12"></line>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
          </svg>
        </button>
        <div class="control-divider"></div>
        <button class="map-control-btn map-type" (click)="toggleMapType()" [class.active]="isSatellite"
          title="Toggle Satellite View">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="2" y1="12" x2="22" y2="12"></line>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
          </svg>
        </button>
        <div class="control-divider"></div>
        <button class="map-control-btn view-3d" (click)="toggle3D()" [class.active]="is3D" title="Toggle 3D View">
          <span style="font-weight: 700; font-size: 15px; font-family: sans-serif;">3D</span>
        </button>
        <div class="control-divider"></div>
        <button class="map-control-btn traffic" (click)="toggleTraffic()" [class.active]="showTraffic"
          title="Toggle Traffic">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2v20M2 12h20" />
            <path d="M18 8l4 4-4 4M6 8l-4 4 4 4" />
          </svg>
        </button>
        <div class="control-divider"></div>
        <button class="map-control-btn center" (click)="reCenterMap()" title="Center to Driver">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="22" y1="12" x2="18" y2="12"></line>
            <line x1="6" y1="12" x2="2" y2="12"></line>
            <line x1="12" y1="6" x2="12" y2="2"></line>
            <line x1="12" y1="22" x2="12" y2="18"></line>
          </svg>
        </button>
        <div class="control-divider"></div>
        <button class="map-control-btn fit-all" (click)="fitRoute()" title="Fit Full Route">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 14l6-6 4 4 6-6" />
            <path d="M14 6h6v6" />
          </svg>
        </button>
        <div class="control-divider"></div>
        <button class="map-control-btn fit-all" (click)="fitAllDrivers()" title="Fit All Drivers">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z" />
          </svg>
        </button>
        <div class="control-divider"></div>
        <button class="map-control-btn zoom-in" (click)="zoomIn()" title="Zoom In">
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
          </svg>
        </button>
        <div class="control-divider"></div>
        <button class="map-control-btn zoom-out" (click)="zoomOut()" title="Zoom Out">
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M20 12H4" />
          </svg>
        </button>
      </div>
    </google-map>

    <google-map *ngIf="!isComponent" class="GoogleMap" width="100%" [height]="data.height ? data.height : '75px'"
      [center]="initialCoordinates" [options]="mapOptions" (mapDragstart)="onMapDragStart()"
      (mapDragend)="onMapDragEnd()" (zoomChanged)="onMapZoomChanged()">
      <map-traffic-layer *ngIf="showTraffic"></map-traffic-layer>

      <!-- Manual Recalculate Route Button -->
      <div *ngIf="isOffRoute && selectedDriverOrderData?.destination"
        style="position: absolute; left: 50%; top: 35%; transform: translate(-50%, -50%); z-index: 1000; pointer-events: auto;">
        <button (click)="drawDriverRouteFromBackend()"
          style="background: #1e293b; color: white; border: 1px solid rgba(255,255,255,0.15); border-radius: 20px; padding: 8px 20px; font-size: 13px; font-weight: 600; cursor: pointer; box-shadow: 0 8px 16px rgba(0,0,0,0.4); display: flex; align-items: center; gap: 8px; transition: all 0.2s; backdrop-filter: blur(10px);"
          onmouseover="this.style.background='#334155'; this.style.transform='scale(1.02)';"
          onmouseout="this.style.background='#1e293b'; this.style.transform='scale(1)';"
          title="Recalculate route from current position">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="#10b981" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="1 4 1 10 7 10"></polyline>
            <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
          </svg>
          Recalculate Route
        </button>
      </div>

      <ng-container *ngIf="data?.isShowDirections || locatedriver || data?.isDriverDetail">
        <map-polyline *ngIf="trimmedRoutePath && trimmedRoutePath.length > 0" [path]="trimmedRoutePath"
          [options]="{ strokeColor: isOffRoute ? 'transparent' : '#0088FF', strokeOpacity: 0.8, strokeWeight: 5 }">
        </map-polyline>
      </ng-container>
      <div class="map-controls-stack">
        <button class="map-control-btn fullscreen" (click)="toggleFullscreen()" [class.active]="isFullscreen"
          title="Toggle Fullscreen">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3">
            </path>
          </svg>
        </button>
        <div class="control-divider"></div>
        <button class="map-control-btn dark-mode" (click)="toggleDarkMode()" [class.active]="isDarkMode"
          title="Toggle Dark Mode">
          <!-- Moon Icon (when off) / Sun Icon (when on) -->
          <svg *ngIf="!isDarkMode" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
          </svg>
          <svg *ngIf="isDarkMode" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="5"></circle>
            <line x1="12" y1="1" x2="12" y2="3"></line>
            <line x1="12" y1="21" x2="12" y2="23"></line>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
            <line x1="1" y1="12" x2="3" y2="12"></line>
            <line x1="21" y1="12" x2="23" y2="12"></line>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
          </svg>
        </button>

        <div class="control-divider"></div>

        <button class="map-control-btn map-type" (click)="toggleMapType()" [class.active]="isSatellite"
          title="Toggle Satellite View">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="2" y1="12" x2="22" y2="12"></line>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
          </svg>
        </button>

        <div class="control-divider"></div>

        <button class="map-control-btn view-3d" (click)="toggle3D()" [class.active]="is3D" title="Toggle 3D View">
          <span style="font-weight: 700; font-size: 15px; font-family: sans-serif;">3D</span>
        </button>

        <div class="control-divider"></div>

        <button class="map-control-btn traffic" (click)="toggleTraffic()" [class.active]="showTraffic"
          title="Toggle Traffic">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2v20M2 12h20" />
            <path d="M18 8l4 4-4 4M6 8l-4 4 4 4" />
          </svg>
        </button>

        <div class="control-divider"></div>

        <button class="map-control-btn center" (click)="reCenterMap()" title="Center to Driver">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="22" y1="12" x2="18" y2="12"></line>
            <line x1="6" y1="12" x2="2" y2="12"></line>
            <line x1="12" y1="6" x2="12" y2="2"></line>
            <line x1="12" y1="22" x2="12" y2="18"></line>
          </svg>
        </button>

        <div class="control-divider"></div>

        <button class="map-control-btn fit-all" (click)="fitRoute()" title="Fit Full Route">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 14l6-6 4 4 6-6" />
            <path d="M14 6h6v6" />
          </svg>
        </button>

        <div class="control-divider"></div>

        <button class="map-control-btn fit-all" (click)="fitAllDrivers()" title="Fit All Drivers">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z" />
          </svg>
        </button>

        <div class="control-divider"></div>

        <button class="map-control-btn zoom-in" (click)="zoomIn()" title="Zoom In">
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
          </svg>
        </button>

        <div class="control-divider"></div>

        <button class="map-control-btn zoom-out" (click)="zoomOut()" title="Zoom Out">
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M20 12H4" />
          </svg>
        </button>
      </div>
    </google-map>
  </div>

  <div *ngIf="!hideBottomSheet && (data?.isShowDirections || data?.isDriverDetail || (locatedriver && selectedDriverOrderData))"
    class="premium-tracking-panel compact-black-theme" [class.collapsed]="isPanelCollapsed">

    <!-- Collapse Toggle Button -->
    <button class="panel-collapse-toggle" (click)="togglePanel()"
      [title]="isPanelCollapsed ? 'Expand Panel' : 'Minimize Panel'">
      <svg *ngIf="!isPanelCollapsed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clip-rule="evenodd" />
      </svg>
      <svg *ngIf="isPanelCollapsed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd"
          d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
          clip-rule="evenodd" />
      </svg>
    </button>

    <!-- Collapsed State (Pill) -->
    <div class="panel-collapsed-content" *ngIf="isPanelCollapsed" (click)="togglePanel()">
      <div class="driver-avatar-wrapper small">
        <div class="avatar-circle">
          <img *ngIf="selectedDriverProfileImage" [src]="selectedDriverProfileImage" alt="Driver Profile"
            style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;" />
          <span *ngIf="!selectedDriverProfileImage">{{ data?.isShowDirections ?
            (this.data.orderData?.current_driver?.first_name?.[0] || 'D') : (selectedDriverLabel?.[0] || 'D') }}</span>
        </div>
        <div class="status-indicator" [ngClass]="isSelectedDriverOnline ? 'online' : 'offline'"></div>
      </div>
      <div class="collapsed-info">
        <span class="collapsed-name">{{ data?.isShowDirections ? (this.data.orderData?.current_driver?.first_name) :
          (selectedDriverLabel?.split(' ')?.[0]) }}</span>
        <div class="collapsed-eta-badge">
          <span class="lbl">{{ selectedDriverOrderStatus?.toLowerCase() === 'arrived' ? 'AT' : 'ETA' }}</span>
          <span class="val">{{ selectedDriverOrderStatus?.toLowerCase() === 'arrived'
            ? (((selectedDriverOrderData?.arrived_at || data?.orderData?.arrived_at) | date: 'hh:mm a') ||
            selectedDriverOrderData?.arrived_at || data?.orderData?.arrived_at || 'N/A')
            : (selectedDriverOrderData?.eta ? (selectedDriverOrderData?.eta | date: 'hh:mm a') : (estimatedTime ||
            '...'))
            }}</span>
        </div>
      </div>
    </div>

    <!-- Expanded State (Full Details) -->
    <div class="panel-content grid-3-col-layout" *ngIf="!isPanelCollapsed"
         [ngStyle]="{'grid-template-columns': (selectedDriverOrderData?.order_type?.toLowerCase() === 'warehouse') ? '140px 1fr' : '140px auto 140px'}">
      <!-- COLUMN 1: Driver Section -->
      <div class="driver-info-left">
        <div class="driver-avatar-wrapper">
          <div class="avatar-circle">
            <img *ngIf="selectedDriverProfileImage" [src]="selectedDriverProfileImage" alt="Driver Profile"
              style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;" />
            <span *ngIf="!selectedDriverProfileImage">{{ data?.isShowDirections ?
              (this.data.orderData?.current_driver?.first_name?.[0] || 'D') : (selectedDriverLabel?.[0] || 'D')
              }}</span>
          </div>
          <div class="status-indicator" [ngClass]="isSelectedDriverOnline ? 'online' : 'offline'"></div>
        </div>
        <div class="driver-details">
          <h4 class="driver-name">
            {{ data?.isShowDirections ? (this.data.orderData?.current_driver?.first_name + ' ' +
            this.data.orderData?.current_driver?.last_name) : selectedDriverLabel }}
          </h4>
          <div style="display: flex; align-items: center; gap: 6px; margin-top: 2px;">
            <span *ngIf="isSelectedDriverHD" class="hd-badge"
              style="background: linear-gradient(135deg, #f59e0b, #d97706); color: #ffffff; padding: 1px 5px; border-radius: 4px; font-size: 9px; font-weight: 800; letter-spacing: 0.5px; box-shadow: 0 1px 3px rgba(0,0,0,0.3); display: inline-flex; align-items: center; justify-content: center; height: 14px; box-sizing: border-box; line-height: 1;">HD</span>
            <span class="driver-phone" *ngIf="data?.isShowDirections && !selectedDriverOrderStatus">{{
              this.data.orderData?.current_driver?.phone_number || 'N/A' }}</span>
            <span class="driver-phone" *ngIf="!data?.isShowDirections && !selectedDriverOrderStatus">No Active
              Order</span>
          </div>
        </div>
      </div>

      <!-- COLUMN 2: Live Logistics & Order Context -->
      <div class="logistics-middle-col" 
           [style.border-right]="(selectedDriverOrderData?.order_type?.toLowerCase() === 'warehouse') ? 'none' : ''"
           [style.padding-right]="(selectedDriverOrderData?.order_type?.toLowerCase() === 'warehouse') ? '40px' : ''"
           style="gap: 4px; justify-content: center;">
        <div class="primary-metrics-row unified-metrics-bar" style="flex-direction: row; justify-content: center; align-items: center; gap: 16px;">
          <!-- Item 1: ETA -->
          <div class="metric-item main-eta">
            <span class="metric-lbl">{{ selectedDriverOrderStatus?.toLowerCase() === 'arrived' ? 'AT' : 'ETA' }}</span>
            <span class="metric-val">{{ selectedDriverOrderStatus?.toLowerCase() === 'arrived'
              ? (((selectedDriverOrderData?.arrived_at || data?.orderData?.arrived_at) | date: 'hh:mm a') ||
              selectedDriverOrderData?.arrived_at || data?.orderData?.arrived_at || 'N/A')
              : (selectedDriverOrderData?.eta ? (selectedDriverOrderData?.eta | date: 'hh:mm a') : (estimatedTime ||
              'Calculating...')) }}</span>
          </div>

          <!-- Divider -->
          <div class="metric-divider"></div>

          <!-- Item 2: Distance -->
          <div class="metric-item">
            <span class="metric-lbl">Distance</span>
            <span class="metric-val">{{ selectedDriverOrderData?.distance || distance || '...' }}</span>
          </div>

          <ng-container *ngIf="selectedDriverOrderData as resolvedOrder">
            <ng-container *ngIf="(resolvedOrder?.order_no || resolvedOrder?.po) && resolvedOrder?.order_type?.toLowerCase() !== 'warehouse'">
              <!-- Divider -->
              <div class="metric-divider"></div>

              <!-- Item 3: Order No -->
              <div class="metric-item">
                <span class="metric-lbl">Order No</span>
                <span class="metric-val">{{ resolvedOrder?.order_no || resolvedOrder?.po }}</span>
              </div>
              
              <ng-container *ngIf="resolvedOrder?.order_type">
                <!-- Divider -->
                <div class="metric-divider"></div>

                <!-- Item 4: Type -->
                <div class="metric-item">
                  <span class="metric-lbl">Type</span>
                  <span class="metric-val" style="text-transform: capitalize;"
                    [ngStyle]="{'color': resolvedOrder?.order_type?.toLowerCase() === 'pickup' ? '#DB2777' : (resolvedOrder?.order_type?.toLowerCase() === 'warehouse' ? '#1e40af' : '#008A51')}">{{
                    resolvedOrder?.order_type }}</span>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>

        <!-- Bottom Row: Address & Status -->
        <div class="address-card" style="margin: 0; background: rgba(255, 255, 255, 0.08); justify-content: center;">
          <span *ngIf="selectedDriverOrderStatus" class="order-status-badge"
            [ngClass]="selectedDriverOrderStatus.toLowerCase()">{{ selectedDriverOrderStatus }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
          </svg>
          <span class="address-text" title="{{ selectedDriverOrderData?.destination?.address }}">
            {{ selectedDriverOrderData?.destination?.address || 'N/A' }}
          </span>
        </div>
      </div>

      <!-- COLUMN 3: Customer Contact -->
      <div class="destination-right-col" *ngIf="selectedDriverOrderData?.order_type?.toLowerCase() !== 'warehouse'"
        style="align-items: flex-start; padding-left: 12px; padding-right: 28px; overflow: hidden;">
        <ng-container *ngIf="selectedDriverOrderData as resolvedCustomerOrder">
          <ng-container *ngIf="(resolvedCustomerOrder?.customer_no || resolvedCustomerOrder?.customer_phone || resolvedCustomerOrder?.customer_name) && resolvedCustomerOrder?.order_type?.toLowerCase() !== 'warehouse'">
            <div
              style="font-size: 10px; color: #94a3b8; text-transform: uppercase; font-weight: 600; letter-spacing: 0.5px; margin-bottom: 2px; white-space: nowrap;">
              Customer Info</div>
            <h4 class="driver-name"
              style="margin: 0; font-size: 13px; font-weight: 700; color: #f8fafc; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%; margin-bottom: 6px;"
              [title]="resolvedCustomerOrder?.customer_name || 'Customer'">
              {{ resolvedCustomerOrder?.customer_name || 'Customer' }}
            </h4>
            <div style="display: flex; align-items: center; gap: 8px; margin-top: 2px;">
              <!-- Phone Number Text -->
              <span style="font-size: 13px; font-weight: 600; color: #cbd5e1; white-space: nowrap; line-height: 1;">
                {{ resolvedCustomerOrder?.customer_no || resolvedCustomerOrder?.customer_phone || 'No phone' }}
              </span>

              <!-- Small Circular Call Button (Only if valid) -->
              <a *ngIf="isValidPhoneNumber(resolvedCustomerOrder?.customer_no || resolvedCustomerOrder?.customer_phone)"
                 [href]="'tel:' + (resolvedCustomerOrder?.customer_no || resolvedCustomerOrder?.customer_phone)" 
                 style="display: flex; align-items: center; justify-content: center; background: rgba(16, 185, 129, 0.1); border: 1px solid rgba(16, 185, 129, 0.3); color: #10b981; border-radius: 50%; width: 20px; height: 20px; text-decoration: none; cursor: pointer; transition: all 0.2s; flex-shrink: 0;"
                 onmouseover="this.style.background='rgba(16, 185, 129, 0.2)'; this.style.borderColor='rgba(16, 185, 129, 0.5)';"
                 onmouseout="this.style.background='rgba(16, 185, 129, 0.1)'; this.style.borderColor='rgba(16, 185, 129, 0.3)';"
                 title="Call Customer">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" style="width: 10px; height: 10px;">
                  <path fill-rule="evenodd" d="M2 3.5A1.5 1.5 0 013.5 2h1.148a1.5 1.5 0 011.465 1.175l.716 3.223a1.5 1.5 0 01-1.052 1.767l-.933.267c-.41.117-.643.555-.48.95a11.542 11.542 0 006.254 6.254c.395.163.833-.07.95-.48l.267-.933a1.5 1.5 0 011.767-1.052l3.223.716A1.5 1.5 0 0118 15.352V16.5a1.5 1.5 0 01-1.5 1.5H15c-1.149 0-2.263-.15-3.326-.43A13.022 13.022 0 012.43 8.326 13.019 13.019 0 012 5V3.5z" clip-rule="evenodd" />
                </svg>
              </a>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>